import { z } from 'zod';
import { financialOverviewSchema } from './financial_overview';
import { keyFiguresSchema } from './key_figures';
import { bookYearSchema, yearMonthSchema } from './periods';

const periodicLedgerDataSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('YearMonth'),
    keyFigures: keyFiguresSchema(yearMonthSchema),
    yearKeyFigures: keyFiguresSchema(bookYearSchema),
    financialOverview: financialOverviewSchema(yearMonthSchema),
  }),
  z.object({
    type: z.literal('BookYear'),
    keyFigures: keyFiguresSchema(bookYearSchema),
    financialOverview: financialOverviewSchema(bookYearSchema),
  }),
]);
type PeriodicLedgerData = z.infer<typeof periodicLedgerDataSchema>;

export { periodicLedgerDataSchema };
export type { PeriodicLedgerData };
